
var sprite = require("/opt/build/repo/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 17.97 8\" id=\"arrow-down\" ><title>arrow-down</title><path d=\"M8.98 8l8.99-6.6L16.9 0 8.98 5.62 1.03 0 0 1.4 8.98 8z\" data-name=\"Layer 2\"/></symbol>";
module.exports = sprite.add(image, "arrow-down");


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-down.svg
// module id = 643
// module chunks = 1474